import { Injectable } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';
import { appConstants } from '../constants/app-constants';
import { AuthService } from './auth.service';
import { UserUtility } from '../utilities/user-utility';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(
    private _authService: AuthService,
  ) {

  }

  canAccessNomOrgPage(): Observable<boolean> {
    return this._authService.hasRoles(
      appConstants.userRole.admin,
      appConstants.userRole.itSupport,
      appConstants.userRole.nominatingOrganisation
    );
  }

  canAccessStandardsLibraryPage(): Observable<boolean> {
    return this._authService.hasRoles(
      appConstants.userRole.admin,
      appConstants.userRole.committeeMember,
      appConstants.userRole.generalManagerOperations,
      appConstants.userRole.itSupport,
      appConstants.userRole.moderator,
      appConstants.userRole.nominatingOrganisation,
      appConstants.userRole.programManager,
      appConstants.userRole.projectManager,
      appConstants.userRole.technicalWriter,
      appConstants.userRole.staff,
      appConstants.userRole.parliamentaryMemberAccess
    );
  }

  canAccessBallotsPage(): Observable<boolean> {
  return combineLatest([
    this._authService.hasRoles(
      appConstants.userRole.admin,
      appConstants.userRole.committeeMember,
      appConstants.userRole.generalManagerOperations,
      appConstants.userRole.itSupport,
      appConstants.userRole.moderator,
      appConstants.userRole.programManager,
      appConstants.userRole.projectManager,
      appConstants.userRole.technicalWriter,
      appConstants.userRole.staff
    ),
    this._authService.user$.pipe(
      map(user => UserUtility.isInternalUser(user))
    )
  ]).pipe(
    map(([hasRoleAccess, isInternalUser]) =>
      hasRoleAccess || isInternalUser
    )
  );
}

  canAccessBallotsCreationPage(): Observable<boolean> {
    return this._authService.hasRoles(
      appConstants.userRole.admin,
      appConstants.userRole.generalManagerOperations,
      appConstants.userRole.itSupport,
      appConstants.userRole.moderator,
      appConstants.userRole.programManager,
      appConstants.userRole.projectManager,
      appConstants.userRole.technicalWriter,
      appConstants.userRole.staff
    );
  }


}
